import { AnimationTypes } from './dialog-types';
import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  OnInit,
  ReflectiveInjector,
  Type,
  ViewChild,
  ViewContainerRef,
  HostListener,
  Renderer2,
  ElementRef,
} from '@angular/core';
import { DialogComponent } from './dialog.component';
import { DialogService, DialogOptions } from './dialog.service';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'dialog-wrapper',
  template: `
    <div #container class="modal" style="display:block !important;" role="dialog" [ngClass]="{'collapsed' : content.IsCollapsed, 'dragging' : IsBeingDragged || IsBeingResized, 'resizable': CanBeResized, 'modal-required' : IsRequired, 'contextChanged' : ContextChanged, 'modal-fullscreen' : IsFullScreen, 'draggable' : !IsFullScreen }">
      <div class="drag-bar"></div>
      <div class="animated {{Animation}}" [ngClass]="{'animated': Animate()}" style="">
        <ng-template #element></ng-template>
      </div>
      <div *ngIf="CanBeResized" class="resize-handle"></div>
    </div>
`
})
export class DialogWrapperComponent implements OnInit {
  Width: number = 800;
  Height: number;
  MinWidth: number = 300;
  MinHeight: number;
  TopPosition: number;
  LeftPosition: number;
  TopOffset: number = 100;
  LeftOffset: number;
  CanBeWindow: boolean = true;
  CanBeMinimized: boolean = true;
  CanBeResized: boolean = true;
  IsBeingDragged: boolean = false;
  IsBeingResized: boolean = false;
  IsRequired: boolean = false;
  ResizeLeft: boolean;
  ResizeRight: boolean;
  ContextChanged: boolean = false;
  IsFullScreen: boolean;

  /**
   * Target element to insert dialog content component
   */
  @ViewChild('element', { read: ViewContainerRef }) public element: ViewContainerRef;

  /**
   * Link container DOM element
   */
  @ViewChild('container') public container: ElementRef;
  @Input('Animation') AnimationType: AnimationTypes = AnimationTypes.None;

  Animation: string = '';

  /**
   * Dialog content componet
   * @type {DialogComponent}
   */
  public content: DialogComponent<any, any>;

  /**
   * Constructor
   * @param {ComponentFactoryResolver} resolver
   * @param {DialogService} dialogService
   */
  constructor(private resolver: ComponentFactoryResolver, private dialogService: DialogService, private cdr: ChangeDetectorRef, private renderer: Renderer2, private router: Router) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        if (this.content.Context && this.content.Context != val.url) {
          this.ContextChanged = true;
        } else if (this.content.Context == val.url) {
          this.ContextChanged = false;
        }
      }
    });
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (event.target['className'].includes('drag-bar')) {
      this.IsBeingDragged = true;
      this.TopOffset = event.offsetY;
      this.LeftOffset = event.offsetX;
      this.renderer.setStyle(this.container.nativeElement, 'left', event.pageX - this.LeftOffset);
      this.renderer.setStyle(this.container.nativeElement, 'top', (event.pageY - event.view.scrollY) - this.TopOffset);
    } else if (event.target['className'].includes('resize-handle')) {
      this.IsBeingResized = true;
      if (event.target['className'].includes('left')) {
        this.ResizeLeft = true;
      } else {
        this.ResizeRight = true;
      }
    }
    this.dialogService.ZIndex++;
    this.renderer.setStyle(this.container.nativeElement, 'z-index', this.dialogService.ZIndex);
  }

  @HostListener('mousemove', ['$event'])
  onmousemove(event: MouseEvent) {
    if (this.IsBeingDragged == true) {
      this.renderer.setStyle(this.container.nativeElement, 'left', event.pageX - this.LeftOffset);
      this.renderer.setStyle(this.container.nativeElement, 'top', (event.pageY - event.view.scrollY) - this.TopOffset);
    } else if (this.IsBeingResized == true) {
      let top = this.container.nativeElement['style']['top'] ? String(this.container.nativeElement['style']['top']).replace('px', '') : 50 ;
      let left = Number(String(this.container.nativeElement['style']['left']).replace('px', '')) - 50;

      if (isNaN(left)) {
        left = (event.view.screen.availWidth / 2) - (this.Width / 2) - 17;
	  }
	  
	  this.renderer.setStyle(this.container.nativeElement, 'height', event.clientY - ((Number(top) - 10)));
      this.renderer.setStyle(this.container.nativeElement, 'width', event.clientX - ( Number(left) ) );
      // Account for negative margin and top position
    }
  }

  @HostListener('mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    this.IsBeingDragged = false;
    this.IsBeingResized = false;
    this.ResizeLeft = false;
    this.ResizeRight = false;
  }

  @HostListener('mouseout', ['$event'])
  onMouseOut(event: MouseEvent) {
  if (this.IsBeingDragged && this.LeftOffset && this.TopOffset) {
      this.renderer.setStyle(this.container.nativeElement, 'left', event.pageX - this.LeftOffset);
      this.renderer.setStyle(this.container.nativeElement, 'top', event.pageY - this.TopOffset);
    } else {
      this.LeftOffset = 0;
      this.TopOffset = 0;
      this.IsBeingDragged = false;
    }
    // this.IsBeingResized = false;
  }

  ngOnInit() {
    this.cdr.detectChanges();
  }

  public Animate(): boolean {

    if (this.AnimationType == AnimationTypes.None) {
      this.Animation = '';
      return false;
    }

    let animation = AnimationTypes[this.AnimationType];
    this.Animation = animation.charAt(0).toLowerCase() + animation.substr(1);

    return true;
  }

  /**
   * Adds content dialog component to wrapper
   * @param {Type<DialogComponent>} component
   * @return {DialogComponent}
   */
  addComponent<T, T1>(component: Type<DialogComponent<T, T1>>, options?: DialogOptions, context?: any) {
    let factory = this.resolver.resolveComponentFactory(component);
    let injector = ReflectiveInjector.fromResolvedProviders([], this.element.injector);
    let componentRef = factory.create(injector);
    this.element.insert(componentRef.hostView);
    this.content = <DialogComponent<T, T1>>componentRef.instance;
    this.content.wrapper = this;

    if (!options.IsFullScreen) {
        if (options.width) {
            this.Width = options.width;
		}

		if (options.height) {
		this.Height = options.height;
		this.renderer.setStyle(this.container.nativeElement, 'width', this.Width);
		this.renderer.setStyle(this.container.nativeElement, 'height', this.Height);
		} else {

		// this.renderer.setStyle(this.container.nativeElement, 'height', this.container.nativeElement.querySelector('.modal-dialog').offsetHeight);
		this.renderer.setStyle(this.container.nativeElement, 'height', 'auto');
		}

		if (options.CanBeMinimized == false) {
		this.CanBeMinimized = options.CanBeMinimized;
		}

		if (options.CanBeResized == false) {
		this.CanBeResized = options.CanBeResized;
		}

		if (options.CanBeWindow == false) {
		this.CanBeWindow = options.CanBeWindow;
		}

		if (options.IsRequired == true) {
		this.IsRequired = options.IsRequired;
		}

		this.renderer.setStyle(this.container.nativeElement, 'width', this.Height + 'px');
		this.renderer.setStyle(this.container.nativeElement, 'width', this.Width + 'px');
	
		this.renderer.setStyle(this.container.nativeElement, 'top', this.TopOffset + 'px');

		let newLeft : number = ((window.innerWidth) / 2) - ((this.Width) / 2);
		this.renderer.setStyle(this.container.nativeElement, 'left', newLeft  + 'px');

    } else {
		
		this.IsFullScreen = true;
	
	}

	

    this.renderer.setStyle(this.container.nativeElement, 'z-index', this.dialogService.ZIndex);

    setTimeout(() => {
      let checkboxes = this.container.nativeElement.querySelectorAll('input[type="checkbox"]');

      checkboxes.forEach(function(checkbox) {
        if (checkbox.attributes['id']) {
          let id = checkbox.attributes['id'].value + '_' + Math.floor(Math.random() * (999999 - 0 + 1) + 0);
          let label = this.container.nativeElement.querySelector('label[for="' + checkbox.attributes['id'].value + '"]');
          checkbox.attributes['id'].value = id;
          label.attributes['for'].value = id;
        }
      }, this);
    }, 500);

    return this.content;
  }

  /**
   * Registers event handler to close dialog by click on backdrop
   */
  closeByClickOutside() {
    const containerEl = this.container.nativeElement;
    containerEl.querySelector('.modal-content').addEventListener('click', (event) => {
      event.stopPropagation();
    });
    containerEl.addEventListener('click', () => {
      this.dialogService.removeDialog(this.content);
    }, false);
  }

}


